import React, { useState } from 'react';
import { useAddRegionSnacksMutation, useAddSnacksMutation } from '../teaAndSnacksApiSlice';
import toast from 'react-hot-toast';
import { Button, TextField, Typography } from '@mui/material';

const SnackDataForm = ({ setIsSnackEntered, isAhmedabadOffice }) => {
  const [snack, setSnack] = useState('');
  const [healthy, setHealthy] = useState('');
  const [addSnackData] = useAddSnacksMutation();
  const [addRegionSnackData] = useAddRegionSnacksMutation();
  const location = localStorage.getItem('location');
  const setData = async () => {
    const dateToday = new Date(new Date().toDateString()).getTime();
    if (isAhmedabadOffice) {
      await toast.promise(addSnackData({ date: dateToday, snack, healthy }).unwrap(), {
        loading: 'Adding...',
        success: 'Food Item Added',
        error: (err) => err.data?.message || 'Error adding item. Please try again.',
      });
      setIsSnackEntered(true);
    } else {
      let params = {
        date: dateToday,
        region: location,
        snack: snack,
      };
      await toast.promise(addRegionSnackData(params).unwrap(), {
        loading: 'Adding...',
        success: 'Food Item Added',
        error: (err) => err.data?.message || 'Error adding item. Please try again.',
      });
      setIsSnackEntered(true);
    }
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px' }}
    >
      {isAhmedabadOffice ? (
        <Typography>Enter todays Snack & Healthy</Typography>
      ) : (
        <Typography>Enter today's Snack</Typography>
      )}
      <TextField
        id="outlined-basic"
        label="Snack"
        variant="outlined"
        value={snack}
        onChange={(e) => {
          setSnack(e.target.value);
        }}
        required
      />
      {isAhmedabadOffice && (
        <TextField
          id="outlined-basic"
          label="Healthy"
          variant="outlined"
          value={healthy}
          onChange={(e) => {
            setHealthy(e.target.value);
          }}
          required
        />
      )}
      <Button
        variant="outlined"
        onClick={setData}
        disabled={isAhmedabadOffice ? snack == '' || healthy == '' : snack == ''}
      >
        Save
      </Button>
    </div>
  );
};

export default SnackDataForm;
